@if (hasFinalized$ | async) {
  <div class="checked button">
    <mat-icon class="material-symbols-outlined"> library_add_check</mat-icon>
    <span>FINALIZED SAMPLE</span>
  </div>
} @else if (isReviewed$ | async) {
  <div class="checked button">
    <mat-icon class="material-symbols-outlined"> check_circle</mat-icon>
    <span>REVIEWED</span>
    <ng-container *ngTemplateOutlet="finalizeSampleDropdown"></ng-container>
  </div>
} @else if (isLastUnreviewed$ | async) {
  <button mat-flat-button color="primary" (click)="finalizeSample()">
    <div class="button-wrapper button">
      <mat-icon class="material-symbols-outlined"> library_add_check</mat-icon>
      <span>FINALIZE SAMPLE</span>
    </div>
  </button>
} @else {
  <button
    mat-flat-button
    color="primary"
    class="with-dropdown"
    (click)="markAsReviewed()"
  >
    <div class="button-wrapper button">
      <mat-icon class="material-symbols-outlined"> check_circle</mat-icon>
      <span>MARK AS REVIEWED</span>
      <ng-container *ngTemplateOutlet="finalizeSampleDropdown"></ng-container>
    </div>
  </button>
}
<ng-template #finalizeSampleDropdown>
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    class="dropdown"
    (click)="openMenu($event)"
  >
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <button mat-menu-item (click)="finalizeSample()">
      <span>Finalize sample</span>
    </button>
  </mat-menu>
</ng-template>
